var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"modal-head"},[_c('button',{on:{"click":_vm.closeModal}},[_vm._v("×")])]),_c('div',{staticClass:"modal-contenido"},[_c('div',{staticClass:"modal-cuerpo"},[_c('iframe',{staticStyle:{"height":"68vh","width":"100%"},attrs:{"src":_vm.currentIframeStats,"scroll":"no","frameborder":"0"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }